export default __webpack_public_path__ + "static/media/lee.d6325113.png";